export interface CanvasSize {
  w: number;
  h: number;
}

export function scaledCanvasSize(
  freeMode: boolean,
  freeSize: CanvasSize,
  scale: number,
  measuredFlow: CanvasSize
): CanvasSize {
  const base = freeMode ? freeSize : measuredFlow;
  return {
    w: Math.ceil(base.w * scale),
    h: Math.ceil(base.h * scale),
  };
}
